module.exports = __webpack_public_path__ + "footbanner2_1.png?b0765446acd6e0966baf0141b8b0ffff";